<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <div class="title">Manage Contract Type History</div>

      <div *ngIf="loading" style="width: 100%">
        <div style="clear: both"></div>
        <div style="text-align: center; font-size: 1.5rem">
          <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading History...
        </div>
      </div>

      <div *ngIf="!loading && !histories">No contract type history was found</div>

      <div *ngIf="histories">
        <p-table
          [(selection)]="selectedHistory"
          [lazy]="true"
          [paginator]="false"
          [responsive]="true"
          [value]="histories"
          resizableColumns="true"
          rowHover="true"
          sortField=""
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Contract Type</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Updated By</th>
              <th>Updated</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.organisationContractType.name }}</td>
              <td>
                <div (click)="editDate(item, false)">
                  {{ item.startDate | date : 'dd/MM/yyyy' }}
                </div>
              </td>
              <td>
                <div (click)="editDate(item, true)">{{ item.endDate | date : 'dd/MM/yyyy' }}</div>
              </td>
              <td>{{ item.updatedByUserName }}</td>
              <td>
                <div title="{{ item.lastUpdated | date : 'dd/MM/yyyy HH:mm' }}">
                  {{ item.lastUpdated | date : 'dd/MM/yyyy HH:mm' }}
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- DATATABLE DEPRECATED ---
        <p-dataTabl [(selection)]="selectedHistory" [editable]="tru" [lazy]="true" [paginator]="false" [responsive]="true"
                     [value]="histories" resizableColumns="true" rowHover="true" sortField="">

          <p-column [editable]="false" [sortable]="false" [style]="{'width': '25%'}" field="organisationContractType.name"
                    header="Contract Type">
            <ng-template let-col let-item="rowData" pTemplate="editor">
              {{ item.organisationContractType.name }}
            </ng-template>
          </p-column>
          <p-column [editable]="false" [sortable]="false" [style]="{'width': '15%'}" field="startDate"
                    header="Start Date">
            <ng-template let-col let-item="rowData" pTemplate="input">
              <div (click)="editDate(item, false)">{{ item.startDate | date:'dd/MM/yyyy'}}</div>
            </ng-template>
          </p-column>
          <p-column [editable]="false" [sortable]="false" [style]="{'width': '15%'}" field="endDate" header="End Date">
            <ng-template let-col let-item="rowData" pTemplate="input">
              <div (click)="editDate(item, true)">{{ item.endDate | date:'dd/MM/yyyy'}}</div>
            </ng-template>
          </p-column>
          <p-column [editable]="false" [sortable]="false" [style]="{'width': '10%'}" field="updatedByUserName"
                    header="Updated By"></p-column>
          <p-column [editable]="false" [sortable]="false" [style]="{'width': '10%'}" field="lastUpdated"
                    header="Date/Time">
            <ng-template let-item="rowData" pTemplate="body">
              <div title="{{item.lastUpdated | date:'dd/MM/yyyy HH:mm'}}">
                {{ item.lastUpdated | date:'dd/MM/yyyy HH:mm'}}
              </div>
            </ng-template>
          </p-column>
        </p-dataTable>
        -->
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Adjust Date"
  [(visible)]="showDateAdjust"
  [modal]="true"
  [style]="{ width: '400px' }"
  [responsive]="true"
>
  <div>
    <div class="ui-grid-row">
      <div class="ui-g-12">
        <div class="ui-g-4">Select {{ isEndDate ? 'End Date' : 'Start Date' }}</div>
        <div class="ui-g-8">
          <p-calendar
            name="dateToadd"
            [(ngModel)]="selectedDate"
            dataType="date"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            tabindex="1"
            autoWidth="false"
            [style]="{ width: '100%' }"
            appendTo="body"
          ></p-calendar>
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"></div>
    </div>
  </div>
  <div style="float: right">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      label="Save"
      (click)="updateHistory()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="closeEditDialog()"
    ></button>
  </div>
</p-dialog>
